var None = {
    _kind: 'None',
    alt: function (fn) { return fn(); },
    map: function () { return None; },
    then: function () { return None; },
    chain: function () { return None; },
    isNone: function () { return true; },
    isSome: function () { return false; },
    match: function (_a) {
        var none = _a.none;
        return none();
    },
    fold: function (onLeft) { return onLeft(); },
    getOrElse: function (onLeft) { return onLeft(); },
    unwrap: function () { return null; },
};
export default None;
//# sourceMappingURL=None.js.map